import axios from 'axios'
import { getAuthHeaderName, getAuthHeaderPrefix, isAuthEnforced, isCatalogSsoEnabled, redirectToCatalogLogin } from '@/config/api/env.js'
import { authNavigate } from '@/config/api/authNavigate.js'
import { runRefreshHandler, setAccessToken } from '@/config/api/authStore.js'
import { reportError } from '@/observability/errorReporter.js'
import PATHS from '@/routes/paths.js'
import axiosClient from './axiosClient.js'
import { attachHeader, readHeader } from './axiosHeaders.js'

axiosClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (axios.isCancel?.(error) || error?.code === 'ERR_CANCELED') return Promise.reject(error)
    const tags = {
      requestId: readHeader(error?.config, 'X-Request-Id'),
      url: error?.config?.url,
      method: error?.config?.method,
      status: error?.response?.status,
    }
    if (!error?.response || error.response.status !== 401) {
      reportError(error, { source: 'network', tags })
      return Promise.reject(error)
    }
    const original = error.config
    if (!original || original.__siaRetried) {
      reportError(error, { source: 'network', tags })
      return Promise.reject(error)
    }
    const next = await runRefreshHandler()
    if (!next) {
      setAccessToken(null)
      try {
        const { clearAuthSession } = await import('@/services/auth/processAuthSession.js')
        clearAuthSession()
      } catch {
        /* optional in tests */
      }
      if (isAuthEnforced()) {
        if (isCatalogSsoEnabled()) redirectToCatalogLogin('/')
        else authNavigate(PATHS.SIGN_IN, { replace: true })
      }
      reportError(error, { source: 'network', tags })
      return Promise.reject(error)
    }
    original.__siaRetried = true
    attachHeader(original, getAuthHeaderName(), `${getAuthHeaderPrefix()}${next}`)
    return axiosClient.request(original)
  },
)
